// extracted by mini-css-extract-plugin
module.exports = {"points":"ProductPoints_points__ET8ue","ploom":"ProductPoints_ploom___wNAP","pointsQuantity":"ProductPoints_pointsQuantity__Ud5uL"};